import { useTranslations } from 'next-intl';
import { Link } from '../../../../../../navigation';
import FlyoutMenu from './FlyoutMenu';
import Image from 'next/image';

const items = [
  {
    id: 'wishlist',
    iconUrl:
      'https://cdn.winelivery.com/public/sections/occasione_lista_desideri.png',
    rank: 10,
    enabled: true,
    href: '/profile/wishlist',
  },
  {
    id: 'purchases',
    iconUrl:
      'https://cdn.winelivery.com/public/sections/occasione_acquistati_recente.png',
    rank: 20,
    enabled: true,
    href: '/profile/recently-purchased',
  },
  {
    id: 'consigliati',
    iconUrl:
      'https://cdn.winelivery.com/public/sections/occasione_consigliati.png',
    rank: 40,
    enabled: true,
    href: `/shop?tag=consigliati`,
  },
  {
    id: 'bestseller',
    iconUrl: 'https://cdn.winelivery.com/public/sections/best_seller.jpg',
    rank: 50,
    enabled: true,
    href: `/shop?tag=bestseller`,
  },
];

function FlyoutMenuSelections() {
  const t = useTranslations('shop');

  return (
    <FlyoutMenu label={t('navbar.selections.title')} fullWidth>
      <div className="tw-container tw-mx-auto tw-py-4 tw-grid tw-grid-cols-3 xl:tw-grid-cols-5 tw-gap-2 tw-px-2">
        {items
          .filter((item) => item.enabled)
          .map((item) => (
            <Link<any>
              key={item.id}
              href={item.href}
              className="tw-rounded-lg tw-p-6 hover:tw-bg-greyscale-pink tw-text-left tw-no-underline"
            >
              <div className="tw-relative tw-w-16 tw-h-16 tw-mb-2">
                <Image
                  fill
                  className="tw-object-cover tw-rounded"
                  src={item.iconUrl}
                  alt={t(`navbar.selections.${item.id}.title`)}
                />
              </div>
              <h6 className="tw-text-lg tw-font-bold tw-tracking-tight tw-text-greyscale-body tw-m-0 tw-p-0">
                {t(`navbar.selections.${item.id}.title`)}
              </h6>
              <p className="tw-text-sm tw-font-medium tw-tracking-tight tw-text-greyscale-label tw-m-0 tw-p-0">
                {t(`navbar.selections.${item.id}.description`)}
              </p>
            </Link>
          ))}
      </div>
    </FlyoutMenu>
  );
}

export default FlyoutMenuSelections;
